<template>
  <div class="or-content" @click.stop>
    <div class="close iconfont icon-cha" @click="bindClose"></div>
    <div class="title">去点外卖</div>
    <div class="b-list">
      <div
        class="b-item"
        @click="bindClick(item)"
        v-for="(item, index) in btnList"
        :key="index"
        v-buried
        :data-buried="item.buried"
        v-clickBuried
        :data-click-buried="item.clickBuried"
      >
        <img class="b-image" :src="item.image" alt="" />
        <div class="b-text">{{ item.text }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { defaultBtn, hemaBtn } from './data'
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    jumpHema: {
      type: Number,
      default: 0
    },
    takeAway: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      defaultBtnList: defaultBtn,
      hemaBtn: hemaBtn
    }
  },
  computed: {
    btnList() {
      let list = []
      if (this.jumpHema) {
        list = list.concat(this.hemaBtn)
      }
      if (this.takeAway) {
        list = list.concat(this.defaultBtnList)
      }
      return list
    }
  },
  methods: {
    bindClick(item) {
      this.$emit('close', item)
    },
    bindClose() {
      this.$emit('close')
    }
  }
}
</script>
<style lang="scss" scoped>
.or-content {
  animation: mymove 0.3s ease;
  box-sizing: border-box;
  background-color: #fff;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  z-index: 3333;
  padding: 17px 20px 37px;

  .close {
    width: 15px;
    height: 15px;
    padding: 10px;
    right: 0px;
    top: 0px;
    position: absolute;
    color: #000;
    font-size: 16px;
  }

  .title {
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.8);
    line-height: 20px;
    margin-bottom: 19px;
  }

  .b-list {
    display: flex;
    align-items: center;
    justify-content: space-around;

    .b-item {
      .b-image {
        width: 50px;
        height: 50px;
        object-fit: contain;
        margin-bottom: 6px;
      }

      .b-text {
        text-align: center;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.7);
        line-height: 17px;
      }
    }

    .b-item:last-child {
      margin-right: 0;
    }
  }
}

@keyframes mymove {
  0% {
    transform: translateY(100%);
  }

  100% {
    transform: translateY(0%);
  }
}
</style>
